import { Box, styled } from "@mui/material";

const FlexBox = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
}));

export default FlexBox as typeof Box;
